import React from 'react';
import PropTypes from 'prop-types';

import { isEmpty, filter, map } from 'lodash';
import { List } from 'material-ui/List';

import { TABLE, HTML } from '../constants/DataTypes';
import DetailListItem from './DetailListItem';

const DetailList = ({ dataSource, containerStyle, itemMaxWidth }) => {
  const filtered = filter(dataSource, f => f.value > Number.MIN_VALUE || !isEmpty(f.value));
  return (
    <List
      style={{
        paddingTop: 0,
        paddingBottom: 0,
        display: 'flex',
        flexWrap: 'wrap',
        ...containerStyle,
      }}
    >
      {map(filtered, (l, i) => (
        <div key={i} style={{ width: '100%', maxWidth: (l.type === TABLE || l.type === HTML) ? 'none' : itemMaxWidth }}>
          <DetailListItem {...l} />
        </div>
      ))}
    </List>
  );
};

DetailList.propTypes = {
  dataSource: PropTypes.array,
  containerStyle: PropTypes.object,
  itemMaxWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

DetailList.defaultProps = {
  itemMaxWidth: 250,
};

export default DetailList;



// WEBPACK FOOTER //
// ./src/components/DetailList.js